export function buildAnalyticsManageProfileGroupSearch(id?: number): string {
  const params = new URLSearchParams();
  params.set('analyticsGroup', '1');
  if (id !== undefined && Number.isFinite(id)) {
    params.set('id', String(id));
  }
  return `?${params.toString()}`;
}
